import AssociationDefinition from 'automation-ui-associations/records/AssociationDefinition';
export default function formatAssociationDefinitions(definitionObjects) {
  const allDefinitions = definitionObjects.map(definition => new AssociationDefinition(definition));
  return {
    allDefinitions
  };
}